var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-control"},[_c('GlSelectButton',{attrs:{"disabled":_vm.disabled,"grey":"","options":_vm.getExposureTableOptions,"value":_vm.getActiveExposureTable},on:{"input":_vm.exposureChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }